import React from 'react';
import { Box, Card, CardContent, LinearProgress, Stack, Typography } from '@mui/material';
import Client from '../Client';
import BackofficeReportsApi from './backofficeReportsApi';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

class OverviewProductsSoldMTD extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      data: {},
      filterData: {}
    };
  }

  componentDidMount() {
    let queryData = {};
    let data = BackofficeReportsApi.getProductsSoldMtd(this.state.client, queryData);

    if (data) {
      this.setState({ data: data });
    }

    this.setState({ filterData: queryData });
  }

  render() {
    let productsSold = 0;
    let activeProducts = 0;
    let soldRate = 0;

    if (this.state.data) {
      if (this.state.data.Products_sold_MTD !== undefined) {
        productsSold = parseInt(this.state.data.Products_sold_MTD);
      }

      if (this.state.data.Active_products !== undefined) {
        activeProducts = parseInt(this.state.data.Active_products);
      }

      if (this.state.data.Sold_rate !== undefined) {
        soldRate = parseFloat(this.state.data.Sold_rate);
      }
    }

    const safeProgress = Math.max(0, Math.min(soldRate, 100));

    const displayValue =
      productsSold > 1000
        ? thousandsSeparator((productsSold / 1000).toFixed(1)) + "K"
        : thousandsSeparator(productsSold.toFixed(0));

    return (
      <Card
        sx={{
          overflow: 'hidden',
          position: 'relative',
          borderRadius: { xs: '14px', sm: '16px' },
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          background: 'linear-gradient(180deg, #ffffff 0%, #fbfcff 100%)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 4,
            background: '#1a237e',
          },
        }}
      >
        <CardContent
          sx={{
            height: '100%',
            boxSizing: 'border-box',
            p: { xs: 1.5, sm: 1.75, md: 2 },
            '&:last-child': {
              pb: { xs: 1.5, sm: 1.75, md: 2 },
            },
          }}
        >
          <Stack
            sx={{
              height: '100%',
              minHeight: { xs: 104, sm: 118 },
            }}
            justifyContent="space-between"
            spacing={1.25}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  lineHeight: 1.2,
                  color: '#1a237e',
                  fontWeight: 800,
                  letterSpacing: '.015em',
                  fontSize: { xs: '0.74rem', sm: '0.8rem', md: '0.84rem' },
                  textTransform: 'uppercase',
                }}
              >
                Products sold MTD
              </Typography>

              <Typography
                sx={{
                  mt: 0.6,
                  fontWeight: 800,
                  lineHeight: 1,
                  color: '#111827',
                  fontSize: { xs: '2rem', sm: '2.2rem', md: '2.35rem' },
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {displayValue}
              </Typography>
            </Box>

            <Box sx={{ width: '100%' }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.6 }}>
                <Typography
                  color="text.secondary"
                  sx={{
                    fontSize: { xs: '0.72rem', sm: '0.78rem' },
                    fontWeight: 700,
                    lineHeight: 1.2,
                  }}
                >
                  Of active
                </Typography>

                <Typography
                  sx={{
                    color: '#1a237e',
                    fontSize: { xs: '0.72rem', sm: '0.78rem' },
                    fontWeight: 800,
                    lineHeight: 1.2,
                  }}
                >
                  {soldRate.toFixed(1)}% of {activeProducts}
                </Typography>
              </Stack>

              <LinearProgress
                value={safeProgress}
                variant="determinate"
                sx={{
                  height: 8,
                  borderRadius: 999,
                  bgcolor: 'rgba(26, 35, 126, 0.10)',
                  '& .MuiLinearProgress-bar': {
                    borderRadius: 999,
                    bgcolor: '#1a237e',
                  },
                }}
              />
            </Box>
          </Stack>
        </CardContent>
      </Card>
    );
  }
}

export default OverviewProductsSoldMTD;
